import { type MutateOptions, useMutation } from '@tanstack/react-query';
import { apiClient } from '@/_config/lib/axios/api-client';
import { handleResponseThrowError } from '@/_utils/services';

interface PutLeaveEstablishmentParams {
  deliverymanId: string;
}

export const putLeaveEstablishment = async ({
  deliverymanId,
}: PutLeaveEstablishmentParams) => {
  return apiClient
    .put(`/corridas/leave-establishment`, {
      deliverymanId,
    })
    .then(response => response.data)
    .catch(handleResponseThrowError('Não foi possível realizar a ação', false));
};

export const usePutLeaveEstablishment = (
  options: Omit<
    MutateOptions<unknown, Error, PutLeaveEstablishmentParams>,
    'mutationFn'
  > = {},
) => {
  return useMutation({
    mutationFn: putLeaveEstablishment,
    ...options,
  });
};
